import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ConflictDialog } from "@/components/ConflictDialog";
import { api, errMsg, isConflict } from "@/lib/api";

const FIELDS = [
  ["w_old", "Weight — oldest 6 months", "0.20", "0.01"], ["w_mid", "Weight — middle 3 months", "0.30", "0.01"],
  ["w_new", "Weight — latest 3 months", "0.50", "0.01"], ["trend_x", "Trend multiplier (latest 3 vs earlier)", "1.1", "0.01"],
  ["min_day", "Use running pace from day of month", "10", "1"], ["event_uplift", "Event uplift", "1.0", "0.01"],
  ["safety_factor", "Safety factor", "1.5", "0.01"],
];

const check = (s) => {
  const n = (k) => Number(s[k]);
  if (Math.round((n("w_old") + n("w_mid") + n("w_new")) * 1e6) !== 1e6) return "w_old + w_mid + w_new must equal 1.00";
  if (!(n("trend_x") > 0 && n("event_uplift") > 0 && n("safety_factor") > 0)) return "Trend, event uplift and safety factor must be more than 0";
  if (!Number.isInteger(n("min_day")) || n("min_day") < 1 || n("min_day") > 31) return "Min day must be a whole number 1–31";
  if (["w_old", "w_mid", "w_new"].some((k) => !(n(k) >= 0))) return "Weights cannot be negative";
  return "";
};

export const ForecastSettings = ({ isAdmin }) => {
  const [s, setS] = useState(null);
  const [conflict, setConflict] = useState(false);
  useEffect(() => { api.get("/settings/forecast").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const err = check(s);
  const save = async (e) => {
    e.preventDefault();
    try {
      const body = { ...Object.fromEntries(FIELDS.map(([k]) => [k, Number(s[k])])), expected_rev: s.rev || 0 };
      setS((await api.put("/settings/forecast", body)).data);
      toast.success("New forecast settings saved");
    } catch (er) { if (isConflict(er)) setConflict(true); else toast.error(errMsg(er)); }
  };
  return (
    <div className="mt-6" data-testid="forecast-settings">
      <div className="mb-2 text-sm font-semibold">30-day forecast (Sales & Forecast page)</div>
      <form onSubmit={save} className="panel divide-y divide-border">
        {FIELDS.map(([k, label, def, step]) => (
          <div key={k} className="flex items-center justify-between gap-4 p-4">
            <div><div className="text-sm font-medium">{label}</div><div className="text-xs text-muted-foreground">default {def}</div></div>
            <Input type="number" step={step} min="0" disabled={!isAdmin} value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="w-28 text-right font-mono" data-testid={`fc-setting-${k}`} />
          </div>))}
        {isAdmin && <div className="flex items-center justify-end gap-3 p-4">{err && <span className="text-xs text-red-500" data-testid="fc-settings-error">{err}</span>}
          <Button type="submit" disabled={!!err} data-testid="fc-settings-save-btn">Save forecast settings</Button></div>}
      </form>
      <ConflictDialog open={conflict} what="setting" onClose={() => setConflict(false)} onReload={() => api.get("/settings/forecast").then((r) => { setS(r.data); setConflict(false); })} />
    </div>
  );
};
